/**
 * ContestProgram ObjectId for Girl Group naming polls (slug: girl-group).
 * Override with REACT_APP_GIRL_GROUP_PROGRAM_ID when needed.
 */
export const GIRL_GROUP_POLL_PROGRAM_ID =
  process.env.REACT_APP_GIRL_GROUP_PROGRAM_ID || "69e0013cca478212f533a56a";
